import React from 'react';
import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import moment from 'moment';
import {FormattedMessage} from 'react-intl';
import ButtonIcon from '../../../components/button-icon/button-icon.component';
import CartTrash from '../../../assets/icons/cart-trash.svg';
import CartAddCircle from '../../../assets/icons/cart-add-circle.svg';
import CartMinusCircle from '../../../assets/icons/cart-minus-circle.svg';
import useQuery from '../../../useQuery';
import {CartDispatchContext} from '../../../contexts/cart';
import i18n from '../../../i18n';
import splitPrice from '../splitPrice';
import classnames from 'classnames';
import './order-item.scss';
import getTagValue from '../../../utilities/get-tag-value';
import Currency from '../../../components/currency/currency';

const OrderItem = ({entry: {quantity, key, endpointId, untie, maxQuantity, available}, deleteItemAction, serviceById}) => {
    const {locale = 'uk'} = useQuery();
    const dispatch = React.useContext(CartDispatchContext);

    const data = useLazyLoadQuery(
        graphql`
            query orderItemCartPagesQuery($endpointId: String) {
                endpointById(id: $endpointId) {
                    id
                    name
                    price
                    nameUk
                    tags
                    labels
                }
            }
        `,
        {endpointId: endpointId}
    );
    const targetDate = getTagValue(data.endpointById.tags, 'targetDate');
    const itemAction = (type) => {
        return () => {
            dispatch({type: type, payload: key});
        }
    };
    return (
        <div className='order-item padding-1dot5rem background-color-white border-radius-0dot75rem'>
            <p className={classnames('text-lg medium padding-bottom-0dot5rem', {'color-gray-900': available, 'color-gray-400': !available})}>{i18n(serviceById, 'name', locale)} | {i18n(data.endpointById, 'name', locale)}</p>
            <p className={classnames('text-md', {'color-gray-500': available, 'color-gray-300': !available})}>{targetDate ? targetDate: moment(serviceById.target).isValid() ? moment(serviceById.target).format('DD.MM.YYYY') : ''}</p>
            <div className='padding-top-1rem display-flex align-items-center'>
                {!!untie && 
                <>
                <p className={classnames('text-lg medium flex-1', {'color-gray-700': available, 'color-gray-300': !available})}>{i18n(data.endpointById, 'name', locale)} {data.endpointById.price || (untie && untie.price)}</p>
                <div className='display-flex align-items-center order-item__actions'>
                    <ButtonIcon {...{color: 'error', clickHandler: () => deleteItemAction({type: 'reduceQuantity', payload: {entry: key, reduceBy: quantity}})}}>
                        <CartTrash className='width-100percent'/>
                    </ButtonIcon>
                </div>
                </>
                }
                {!untie &&
                    <>
                        <p className={classnames('text-lg medium flex-1 display-flex align-items-center', {'color-gray-900': available, 'color-gray-300': !available})}>
                            <span className='padding-right-0dot125rem'>
                                <span>{splitPrice(data.endpointById.price.toString()).whole}</span>
                                {splitPrice(data.endpointById.price.toString()).fraction && 
                                    <>
                                        <span>.</span>
                                        <span className='text-xs medium'>{splitPrice(data.endpointById.price.toString()).fraction}</span>
                                    </>
                                }
                                <span>{' '}</span>
                            </span>
                            <Currency {...{defaultCurrency: <FormattedMessage defaultMessage='UAH'/>, isStem: data.endpointById.labels && data.endpointById.labels.isStem, stemIconClasses: 'display-block width-1dot25rem height-1dot25rem'}}/>
                        </p>
                        <div className='display-flex align-items-center'>
                            <ButtonIcon {...{color: 'error', clickHandler: () => deleteItemAction({type: 'reduceQuantity', payload: {entry: key, reduceBy: quantity}})}}>
                                <CartTrash className='width-100percent'/>
                            </ButtonIcon>
                            <div className='padding-0dot4375rem border-radius-0dot5rem margin-left-1rem display-flex align-items-center border-1px-solid border-color-gray-100'>
                                <ButtonIcon {...{clickHandler: itemAction('decrement'), disabled: quantity < 2 || !available}}>
                                    <CartMinusCircle className='width-100percent'/>
                                </ButtonIcon>
                                <p className={classnames('margin-left-0dot5rem margin-right-0dot5rem min-width-2rem text-align-center display-inline-block text-md', {'color-gray-700': available, 'color-gray-300': !available})}>{quantity}</p>
                                <ButtonIcon {...{clickHandler: itemAction('increment'), disabled: quantity >= maxQuantity || !available}}>
                                    <CartAddCircle className='width-100percent'/>
                                </ButtonIcon>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    )
};

export default React.memo(OrderItem);